export enum BackstageTheme {
  dark = 'dark',
  light = 'light',
}
